import { RouteObject } from "react-router-dom";
import { NOTIFICATION, NOTIFICATION_DETAIL } from "constants/urls";

export default [
  {
    index: true,
    path: NOTIFICATION,
    lazy: () => import("modules/notification/pages/NotificationList"),
  },
  {
    path: NOTIFICATION_DETAIL,
    lazy: () => import("modules/notification/pages/NotificationDetail"),
  },
] as RouteObject[];
